import CreateEditTaskSidebar, {
  CreateEditTaskFormDefaultValues,
} from '@/ui/components/createEditTaskSidebar/CreateEditTaskSidebar';
import { isNotNullish } from '@payaca/utilities/guards';
import { FC } from 'react';
import { CommitmentItem } from './CommitmentsPanel';

type TaskCommitmentItem = Extract<
  CommitmentItem,
  { __typename: 'TaskCommitment' }
>;

const ArrangeTaskModal: FC<{
  commitment: TaskCommitmentItem;
  projectId?: number;
  onClose: () => void;
  onSuccess: (taskId: number) => void;
}> = (props) => {
  const { commitment, projectId, onClose, onSuccess } = props;

  const template = commitment.template;

  const defaultValues: CreateEditTaskFormDefaultValues = (() => {
    const baseName = template.taskName || 'task';
    const baseNotes = template.taskNotes || '';

    if (
      template.__typename === 'ChecklistTaskTemplate' &&
      template.checklistItems?.length
    ) {
      return {
        type: 'checklist' as const,
        name: baseName,
        notes: baseNotes,
        checklistItems: template.checklistItems.map((x) => ({ label: x })),
      };
    }

    if (
      template.__typename === 'FormTaskTemplate' ||
      template.__typename === 'LegacyFormTaskTemplate'
    ) {
      const formTemplate =
        'formTemplate' in template ? template.formTemplate : null;
      return {
        type: 'form' as const,
        name: baseName,
        notes: baseNotes,
        formId: isNotNullish(formTemplate?.id) ? +formTemplate.id : undefined,
      };
    }

    return {
      type: 'checklist' as const,
      name: baseName,
      notes: baseNotes,
      checklistItems: [],
    };
  })();

  return (
    <CreateEditTaskSidebar
      isOpen={true}
      onClose={onClose}
      projectId={projectId}
      defaultValues={defaultValues}
      onSuccess={onSuccess}
    />
  );
};

export default ArrangeTaskModal;
